import OneSignal from "react-onesignal";
import ReactDOM from "react-dom"
import ConfirmationModal from "../components/ConfirmationModal";
export const shortanName = (name="") => {
  const names = name.split(" ");

  if (names.length > 1) {
    // sort by length of name
    names.sort((a, b) => {
      return b.length - a.length;
    });

    // get first letter of first name

    const firstLetter = names[0].charAt(0);

    return names[1] + " " + names[0].charAt(0);
  }

  return name;
};
export const formatNumberWithCommas = (number) => {
  return number.toLocaleString('en-IN'); // Formats numbers in Indian numbering system
};

// export const formatNumberWithCommas = (number) => {
//   // convert to k for number from > 1000 and < 1000000
//   if (number > 10000 && number < 1000000) {
//     return (number / 1000).toFixed(1) + "k";
//   }

//   // convert to M for number from > 1 million
//   else if (number > 1000000) {
//     return (number / 1000000).toFixed(1) + "M";
//   }

//   // return formatted original number

//   return number.toLocaleString();
// };

export const getCurrency = (currency) => {
  // const { currency = "INR" } = hotel;
  switch (currency) {
    case "INR":
      return "₹";
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "AUD":
      return "A$";

    default:
      return "₹";
  }
};

export const isValid = (value) => {
  if (value == null || value == undefined || value == "") {
    return false;
  }
  return true;
};

export const logOut = () => {
  // Create a div for the modal portal if it doesn't exist
  let modalRoot = document.getElementById("modal-root")
  if (!modalRoot) {
    modalRoot = document.createElement("div")
    modalRoot.id = "modal-root"
    document.body.appendChild(modalRoot)
  }

  // Create a state management object
  const modalState = {
    isOpen: false,
    onConfirm: null,
    onCancel: null,
  }

  // Function to render the modal
  const renderModal = () => {
    const modalDiv = document.createElement("div")
    modalRoot.appendChild(modalDiv)

    const handleConfirm = () => {
      if (modalState.onConfirm) modalState.onConfirm()
      modalState.isOpen = false
      ReactDOM.unmountComponentAtNode(modalDiv)
      modalDiv.remove()
    }

    const handleCancel = () => {
      if (modalState.onCancel) modalState.onCancel()
      modalState.isOpen = false
      ReactDOM.unmountComponentAtNode(modalDiv)
      modalDiv.remove()
    } 

    ReactDOM.render(
      <ConfirmationModal
        isOpen={modalState.isOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        title="Logout Confirmation"
        message="You will be logged out of the application"
        confirmText="Yes, Logout!"
        cancelText="Cancel"
      />,
      modalDiv,
    )
  }

  // Set up the modal state
  modalState.isOpen = true
  modalState.onConfirm = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    window.axios.defaults.headers.common["Authorization"] = ""
    // OneSignal.setExternalUserId("0")
    localStorage.removeItem("cart")
    localStorage.removeItem("cartId")
    localStorage.removeItem("cartCount")
    localStorage.removeItem("cartTotal")
    localStorage.removeItem("cartItems")
    localStorage.removeItem("cartSubTotal")
    localStorage.removeItem("cartTax")
    localStorage.removeItem("cartShipping")
    localStorage.removeItem("cartTotal")

    window.location.reload()
  }

  // Render the modal
  renderModal()
}

export const Capitalize = (str) => {

  if(!str) return str;

  try {
    return str.charAt(0).toUpperCase() + str.slice(1);
  } catch (e) {
    return str;
  }
};

export const trimUnderScore = (str) => {
  try {
    return str.replace(/_/g, " ");
  } catch (e) {
    return str;
  }
};
